import { IIdObject } from '@common/interfaces/id-object.interface';
import { IBoxCustomisationSelection } from '../pack-house-generated-api';

export interface IBoxCustomisationSelectionDto extends Omit<IBoxCustomisationSelection, 'id'>, IIdObject {
    id: string;
}

// relation between subscription id and box-customisation-config
export const createBoxCustomisationSelectionDto = (data: IBoxCustomisationSelection): IBoxCustomisationSelectionDto => {
    return {
        ...data,
        id: data?.id || '',
    };
};
